module.exports = __webpack_public_path__ + "img/important_en.3a8a5859.png";